import React from "react";
import WindowPattern from "./patterns/PatternSelector";

const ThreeLiteCasementDiagram = ({
  selectedValue,
  availableOptions,
  onChange,
  mode,
  disabled,
  formData,
  allAvailableOptions,
}) => {
  // Find options based on mode
  const endLitesOption = availableOptions?.find((opt) =>
    opt.name.toLowerCase().includes("end lites"),
  );
  const allLitesOption = availableOptions?.find((opt) =>
    opt.name.toLowerCase().includes("all lites"),
  );
  const fullWindowOption =
    availableOptions?.find(
      (opt) =>
        !opt.name.toLowerCase().includes("sash") &&
        !opt.name.toLowerCase().includes("lite"),
    ) || availableOptions?.[0];

  // Determine which sections should show pattern
  const getSelectedSections = () => {
    if (mode === "grid") {
      if (selectedValue === endLitesOption?.id) {
        return [true, false, true]; // sections 1 and 3
      } else if (selectedValue === allLitesOption?.id) {
        return [true, true, true]; // all sections
      }
    } else if (mode === "obscurity") {
      // For obscurity, if selected, all panels are obscured
      if (selectedValue) {
        return [true, true, true]; // all sections
      }
    }
    return [false, false, false]; // none
  };

  const selectedSections = getSelectedSections();

  const handleClick = () => {
    if (disabled || mode === "display") return;

    if (mode === "grid") {
      // Cycle through: null/other → End Lites → All Lites → null
      if (
        !selectedValue ||
        (selectedValue !== endLitesOption?.id &&
          selectedValue !== allLitesOption?.id)
      ) {
        onChange(endLitesOption?.id);
      } else if (selectedValue === endLitesOption?.id) {
        onChange(allLitesOption?.id);
      } else if (selectedValue === allLitesOption?.id) {
        onChange(null);
      }
    } else if (mode === "obscurity") {
      // Simple toggle for obscurity
      onChange(selectedValue ? null : fullWindowOption?.id);
    }
  };

  // Get grid style name for pattern
  const selectedGridStyle = allAvailableOptions?.grid_styles?.find(
    (style) => style.id === formData?.grid_style_id,
  );

  return (
    <div className="flex justify-center items-center">
      <div
        className={`
          relative w-36 h-64 bg-light border-8 border-r-0 border-brand
          ${disabled ? "opacity-50" : ""}
        `}
        onClick={handleClick}
      >
        <WindowPattern
          mode={mode}
          isSelected={selectedSections[0]}
          gridStyleName={selectedGridStyle?.name}
        />
      </div>
      <div
        className={`
          relative w-36 h-64 bg-light border-8 border-r-0 border-brand
          ${disabled ? "opacity-50" : ""}
        `}
        onClick={handleClick}
      >
        <WindowPattern
          mode={mode}
          isSelected={selectedSections[1]}
          gridStyleName={selectedGridStyle?.name}
        />
      </div>
      <div
        className={`
          relative w-36 h-64 bg-light border-8 border-brand
          ${disabled ? "opacity-50" : ""}
        `}
        onClick={handleClick}
      >
        <WindowPattern
          mode={mode}
          isSelected={selectedSections[2]}
          gridStyleName={selectedGridStyle?.name}
        />
      </div>
    </div>
  );
};

export default ThreeLiteCasementDiagram;
